import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { useSuspense } from "@rest-hooks/react";
import { ModerationResource } from "../../api/moderation";
import { ThresholdsSection } from "./ThresholdsSection";
import { BlocklistSection } from "./BlocklistSection";
import { AllowlistSection } from "./AllowlistSection";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`config-tabpanel-${index}`}
      aria-labelledby={`config-tab-${index}`}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
};

export interface ConfigurationTabsProps {
  onRefresh: () => void;
}

export const ConfigurationTabs: React.FC<ConfigurationTabsProps> = ({ onRefresh }) => {
  const [tabValue, setTabValue] = useState(0);

  const configResponse = useSuspense(ModerationResource.getConfig);
  const blocklist = useSuspense(ModerationResource.getBlocklist);
  const allowlist = useSuspense(ModerationResource.getAllowlist);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="moderation config tabs">
          <Tab label="Thresholds" id="config-tab-0" />
          <Tab label="Blocklist" id="config-tab-1" />
          <Tab label="Allowlist" id="config-tab-2" />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <ThresholdsSection config={configResponse.config} onRefresh={onRefresh} />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <BlocklistSection blocklist={blocklist} onRefresh={onRefresh} />
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <AllowlistSection allowlist={allowlist} onRefresh={onRefresh} />
      </TabPanel>
    </>
  );
};
